<script>
import VideoLandmarksPlayer from './VideoLandmarksPlayer.vue';

export default {
  name: 'VideoPlayer',
  extends: VideoLandmarksPlayer,
};
</script>
